<template>
  <div class="bookShelf-body">
    <div class="main">
<!--            <h2> &#45;&#45; 我的书架</h2>-->
      <ul class="book-list">
        <li class="book-item" @click="$router.push({ path: '/m/bookReader' })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/bookExample/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="文旌.数字教材">文旌.数字教材</h3>
            <p>金企鹅数字教材研发中心</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
        <li class="book-item" @click="$router.push({ path: '/m/bookReader', query: { book_id: 1 } })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/book1/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="机械制图与AutoCAD">机械制图与AutoCAD</h3>
            <p>主审 胡震</p>
            <p>主编 邵永山 韦兰花</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
        <li class="book-item" @click="$router.push({ path: '/bookReader', query: { book_id: 2 } })">
          <div class="book-pic-box">
            <img src="@/assets/images/books/book2/book-cover.png">
          </div>
          <div class="book-txt">
            <h3 title="新时代大学英语——综合教程2">新时代大学英语——综合教程2</h3>
            <p>主审 张森</p>
            <p>主编 丁国声 滕婷婷 刘学</p>
            <!--                            <p>阅读进度：46%</p>-->
            <span class="tag">试读</span>
          </div>
        </li>
      </ul>
      <div class="bg-logo"><img src="@/assets/images/common/right-bottom-logo.png"></div>
    </div>
  </div>
</template>

<script>
  import sideBar from '@/layout/sideBar.vue'
  export default {
    name: "BookShelf",
    components: {
      sideBar
    }
  }
</script>

<style scoped lang="scss">
.bookShelf-body {
  width: 100%;
  height: 100%;
  display: flex;
  .main {
    width: 100%;
    padding: 30rem 24rem;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    h2 {
      font-size: 24rem;
      padding: 30rem 0;
      text-align: left;
      border-bottom: 1rem solid #2F4058;
    }
    .book-list {
      margin-bottom: 50rem;
      display: flex;
      flex-wrap: wrap;
      gap: 50rem;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: space-between;
      .book-item {
        padding: 30rem 20rem;
        width: 100%;
        //height: 175rem;
        border: 1rem solid #e3e3e3;
        display: flex;
        align-items: center;
        position: relative;
        &:hover{
          background: #f7f7f7;
          border-color: #f7f7f7;
        }
        .book-pic-box {
          margin-right: 20rem;
          width: 176rem;
          height: 240rem;
          img {
            width: 100%;
          }
        }
        .book-txt{
          h3 {
            font-size: 32rem;
            line-height: 44rem;
            height: 88rem;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          p {
            font-size: 24rem;
            margin-top: 6rem;
          }
          span.tag {
            display: block;
            font-size: 28rem;
            color: #fff;
            font-weight: bold;
            padding: 4rem 10rem;
            border-radius: 4rem;
            background: #E9712B;
            position: absolute;
            bottom: 30rem;
            right: 20rem;
          }
        }
      }
    }
    .bg-logo {
      width: 200rem;
      height: auto;
      position: absolute;
      right: 30rem;
      bottom: 30rem;
      img{
        width: 100%;
         opacity: 0.15;
      }
    }
  }
}
</style>
